import DataBinder from "../DataBinder.js"
import SwapPage from "../SwapPage.js"
export default class MoreGamesController {

  constructor(app) {
    this.app = app;
  }
  show(path) {
    const app = this.app;
    const device = app.device;
    const config = app.config;

    app.achievements.awardAchivement(app.userdata, "See More Games");

    //get page
    let pageId = path.split("/")[0];


    const items = app.marketPlace.getGames();

    const model = items;

    const dataBinder = new DataBinder();
    dataBinder.populate(pageId, model);

    const swapPage = new SwapPage();
    swapPage.swapPage(pageId);
  }

  //rate game button
  showGame(game) {
    const app = this.app;

    app.marketPlace.show(game);
  };
}